document.querySelectorAll('[data-hero-carousel]').forEach((carousel) => {
  const slides = carousel.querySelectorAll('[data-hero-slide]');
  const dots = carousel.querySelectorAll('[data-hero-dot]');
  if (slides.length < 2) return;

  const goTo = (index) => {
    const target = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => slide.classList.toggle('is-active', i === target));
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === target));
  };

  carousel.querySelector('[data-hero-next]')?.addEventListener('click', () => {
    const current = [...slides].findIndex((slide) => slide.classList.contains('is-active'));
    goTo(current + 1);
  });

  dots.forEach((dot) => {
    dot.addEventListener('click', () => goTo(Number(dot.dataset.heroDot)));
  });
});
